import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, browserSessionPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration - supports both environment variables and hardcoded values
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAuwZGulA0bPEMRxpU6SWViaX7NynstNYU',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'evalpro2.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'evalpro2',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'evalpro2.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '389709381093',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:389709381093:web:581886e2a8a52a9085430c',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Export session persistence for use in authentication
export { browserSessionPersistence };

export default app;
